import React from 'react';

type Props = { size?: number; color?: string; className?: string; style?: React.CSSProperties };

export const LibreCardsIcon: React.FC<Props> = ({ size = 24, color = 'currentColor', className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size * (28 / 24)} height={size} viewBox="0 0 28 24" fill="none" className={className} style={style}>
    <path d="M5.595 18.784l5.081-17.912A.524.524 0 0010.023 0H7.264a1.35 1.35 0 00-1.306.993L.066 21.769a1.35 1.35 0 001.633 2.18h17.097a1.35 1.35 0 001.307-.993l.44-1.556a.524.524 0 00-.653-.872H6.901a1.35 1.35 0 01-1.306-1.744z" fill={color} />
    <path d="M11.165 17.107h9.562a1.35 1.35 0 001.308-.999l.432-1.553a.524.524 0 00-.654-.869h-5.563a.81.81 0 01-.979-.71L17.607 4.165a.81.81 0 01.979-.744h6.022a1.35 1.35 0 001.304-.987l.449-1.56A.524.524 0 0025.709 0H15.499a1.62 1.62 0 00-1.632 1.24l-4.009 14.122a1.35 1.35 0 001.307 1.745z" fill={color} />
    <path d="M27.27 6.672h-5.122a.81.81 0 00-.978.74l-.62 2.148a.524.524 0 00.652.876h5.122a.81.81 0 00.978-.74l.62-2.148a.524.524 0 00-.652-.876z" fill={color} />
  </svg>
);

export const APP_NAME = 'LibreCards';
